module.exports = __webpack_public_path__ + "img/product_index_icon3.18247494.png";